import actions from './constants';

export const showTaskTemplates = (category, append, pageSize, results, resultsCount, totalPages, currentPage) => ({
  type: actions.SHOW_TASK_TEMPLATES,
  category,
  append,
  pageSize,
  results,
  resultsCount,
  totalPages,
  currentPage,
});

export const showTaskTemplatesError = (category, error) => ({
  type: actions.SHOW_TASK_TEMPLATES_ERROR,
  category,
  error,
});

export const showTaskTemplateForTask = (category, code, taskCode, result) => ({
  type: actions.SHOW_TASK_TEMPLATE_TASK_SUCCESS,
  category,
  code,
  taskCode,
  result,
});

export const showTaskTemplateTaskError = (category, code, taskCode, error) => ({
  type: actions.SHOW_TASK_TEMPLATE_TASK_ERROR,
  category,
  code,
  taskCode,
  error,
});
